import { isEmpty } from "lodash"
import { checkIsHighlighted, DEFAULT_PRIORITY_ORDER, AGGREGATION_PRIORITY_ORDER } from "renderers/contributors-table/helpers"

export const createDataGridRows = ({
  sortedContributorsArray,
  highlightedRowIds,
  currentLevelData,
  isTopLevel,
  currentLevelLabel,
}) => {
  const highlightedStatusMap = sortedContributorsArray.reduce((mapAccumulator, contributor) => {
    const isHighlighted = checkIsHighlighted(contributor, highlightedRowIds)
    return mapAccumulator.set(contributor.id, isHighlighted)
  }, new Map())

  const contributorRows = sortedContributorsArray
    .map((contributor, index) => {
      const isHighlighted = highlightedStatusMap.get(contributor.id)
      const hasPriority = contributor.pinnedRowOrder || isHighlighted

      return {
        id: contributor.id || index,
        contributor,
        label: contributor.label,
        hasPriority,
        priorityOrder: contributor.pinnedRowOrder || DEFAULT_PRIORITY_ORDER,
        isHighlighted,
        isAggregation: false,
      }
    })
    .toSorted((a, b) => b.priorityOrder - a.priorityOrder)

  const pinnedRows = { top: [], bottom: [] }
  if (currentLevelData && !isEmpty(currentLevelData.values)) {
    const aggregationRow = {
      id: "aggregation-row",
      contributor: currentLevelData,
      label: currentLevelData.label || (isTopLevel ? "Total" : currentLevelLabel),
      hasPriority: true,
      priorityOrder: AGGREGATION_PRIORITY_ORDER,
      isHighlighted: false,
      isAggregation: true,
    }
    pinnedRows.top = [aggregationRow]
  }

  return { rows: contributorRows, pinnedRows }
}
